import { useSnackbar } from "notistack";
import { useForm, useFormValidator, useFormField } from "../../../CustomHooks/ComposedForm.fs.js";
import { InspectorType, PersonIdOvam___UnsafeCreate_Z721C83C5, Address, NonEmptyString, TypeOfCorporation$reflection, Region, AdiRoleModule_string, AdiRole, SelectOptionData$1_Create_Z510A3DC0, BankAccount_Create_Z721C83C5, VatNumber_get_Create, NationalInsuranceNumber_Create_Z721C83C5, PhoneNumber_get_Create, Email_get_Create, NonEmptyString_get_Create } from "../../../shared/Domain.fs.js";
import { useFeliz_React__React_useState_Static_1505 } from "../fable_modules/Feliz.1.68.0/React.fs.js";
import { count, empty } from "../fable_modules/fable-library.3.7.17/Set.js";
import { compare } from "../fable_modules/fable-library.3.7.17/Util.js";
import { CreateAddressForm, useAddressForm } from "../../../DesignSystems/AddressHook.fs.js";
import { createElement } from "react";
import { Row, Col } from "../../../Components/UtilComponents.fs.js";
import { MarginTop, Gap } from "../../../Styles/Utils.fs.js";
import { ofArray, singleton } from "../fable_modules/fable-library.3.7.17/List.js";
import { iterate, singleton as singleton_1, append, delay, toList } from "../fable_modules/fable-library.3.7.17/Seq.js";
import { Card, SelectOptionField, OptionField, TextField } from "../../../DesignSystems/DesignSystem.fs.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.1.2.6/./Mui.fs.js";
import RadioGroup from "@material-ui/core/RadioGroup";
import { Interop_reactApi } from "../fable_modules/Feliz.1.68.0/./Interop.fs.js";
import { RegionCheckbox, TermOfPayment, UiCompanyType } from "./AdiCreate.fs.js";
import Button from "@material-ui/core/Button";
import { EnqueueSnackbarOption, SnackbarProp_Variant_Z609E1E86, ProviderContext__enqueueSnackbar_Z1776A768 } from "../../../Notistack/Notistack.fs.js";
import { isNullOrWhiteSpace, isNullOrEmpty } from "../fable_modules/fable-library.3.7.17/String.js";
import { CompanyInformationData, CompanyFormatData, AdiData, CompanyData } from "../../../shared/Api.fs.js";
import { toArray } from "../fable_modules/fable-library.3.7.17/Option.js";
import { Page } from "../components/Page.fs.js";
import { startImmediate } from "../fable_modules/fable-library.3.7.17/Async.js";
import { singleton as singleton_2 } from "../fable_modules/fable-library.3.7.17/AsyncBuilder.js";
import { RouterModule_nav } from "../fable_modules/Feliz.Router.3.10.0/./Router.fs.js";
import { Page$2__toUrl_2B594 } from "../../../BidirectionalRouting/BidirectionalRouting.fs.js";
import { epcInspectors, epcInspectorDetail } from "../AppRoutes.fs.js";

export function CreateEpcInspectorForm(createEpcInspectorFormInputProps) {
    const onCancel = createEpcInspectorFormInputProps.onCancel;
    const onCreate = createEpcInspectorFormInputProps.onCreate;
    const snackbar = useSnackbar();
    const firstName = useFormField("", NonEmptyString_get_Create());
    const lastName = useFormField("", NonEmptyString_get_Create());
    const email = useFormField("", Email_get_Create());
    const phoneNumber = useFormField("", PhoneNumber_get_Create());
    const nationalInsuranceNumber = useFormField("", NationalInsuranceNumber_Create_Z721C83C5);
    const personalIdOvam = useFormField("", (s) => s);
    const emailAsbestConsulting = useFormField("", Email_get_Create());
    const vatNumber = useFormField("", VatNumber_get_Create());
    const bankAccount = useFormField("", BankAccount_Create_Z721C83C5);
    const patternInput = useFeliz_React__React_useState_Static_1505(empty({
        Compare: compare,
    }));
    const setRegionValues = patternInput[1];
    const regionValues = patternInput[0];
    const address = useAddressForm("", "", "", "", "");
    const addressCase = useAddressForm("", "", "", "", "");
    const companyName = useFormField("", NonEmptyString_get_Create());
    const vatLiable = useFormField(void 0, SelectOptionData$1_Create_Z510A3DC0);
    const termOfPayment = useFormField(void 0, SelectOptionData$1_Create_Z510A3DC0);
    const companyType = useFormField(void 0, SelectOptionData$1_Create_Z510A3DC0);
    const companyForm = useFormField(void 0, SelectOptionData$1_Create_Z510A3DC0);
    const telefoon = useFormField("", PhoneNumber_get_Create());
    const emailadres = useFormField("", Email_get_Create());
    const role = useFormField(void 0, SelectOptionData$1_Create_Z510A3DC0);
    const form = useFormValidator(role.Validator, (r_11, x_13) => ({
        Address: r_11.Address,
        BankAccount: r_11.BankAccount,
        CompanyType: r_11.CompanyType,
        Email: r_11.Email,
        EmailAsbestConsulting: r_11.EmailAsbestConsulting,
        FirstName: r_11.FirstName,
        LastName: r_11.LastName,
        NationalInsuranceNumber: r_11.NationalInsuranceNumber,
        PhoneNumber: r_11.PhoneNumber,
        Role: x_13,
        TermOfPayment: r_11.TermOfPayment,
        VatLiable: r_11.VatLiable,
        VatNumber: r_11.VatNumber,
    }), useFormValidator(vatLiable.Validator, (r_10, x_12) => ({
        Address: r_10.Address,
        BankAccount: r_10.BankAccount,
        CompanyType: r_10.CompanyType,
        Email: r_10.Email,
        EmailAsbestConsulting: r_10.EmailAsbestConsulting,
        FirstName: r_10.FirstName,
        LastName: r_10.LastName,
        NationalInsuranceNumber: r_10.NationalInsuranceNumber,
        PhoneNumber: r_10.PhoneNumber,
        TermOfPayment: r_10.TermOfPayment,
        VatLiable: x_12,
        VatNumber: r_10.VatNumber,
    }), useFormValidator(termOfPayment.Validator, (r_9, x_11) => ({
        Address: r_9.Address,
        BankAccount: r_9.BankAccount,
        CompanyType: r_9.CompanyType,
        Email: r_9.Email,
        EmailAsbestConsulting: r_9.EmailAsbestConsulting,
        FirstName: r_9.FirstName,
        LastName: r_9.LastName,
        NationalInsuranceNumber: r_9.NationalInsuranceNumber,
        PhoneNumber: r_9.PhoneNumber,
        TermOfPayment: x_11,
        VatNumber: r_9.VatNumber,
    }), useFormValidator(companyType.Validator, (r_8, x_10) => ({
        Address: r_8.Address,
        BankAccount: r_8.BankAccount,
        CompanyType: x_10,
        Email: r_8.Email,
        EmailAsbestConsulting: r_8.EmailAsbestConsulting,
        FirstName: r_8.FirstName,
        LastName: r_8.LastName,
        NationalInsuranceNumber: r_8.NationalInsuranceNumber,
        PhoneNumber: r_8.PhoneNumber,
        VatNumber: r_8.VatNumber,
    }), useFormValidator(bankAccount.Validator, (r_7, x_9) => ({
        Address: r_7.Address,
        BankAccount: x_9,
        Email: r_7.Email,
        EmailAsbestConsulting: r_7.EmailAsbestConsulting,
        FirstName: r_7.FirstName,
        LastName: r_7.LastName,
        NationalInsuranceNumber: r_7.NationalInsuranceNumber,
        PhoneNumber: r_7.PhoneNumber,
        VatNumber: r_7.VatNumber,
    }), useFormValidator(vatNumber.Validator, (r_6, x_8) => ({
        Address: r_6.Address,
        Email: r_6.Email,
        EmailAsbestConsulting: r_6.EmailAsbestConsulting,
        FirstName: r_6.FirstName,
        LastName: r_6.LastName,
        NationalInsuranceNumber: r_6.NationalInsuranceNumber,
        PhoneNumber: r_6.PhoneNumber,
        VatNumber: x_8,
    }), useFormValidator(emailAsbestConsulting.Validator, (r_5, x_7) => ({
        Address: r_5.Address,
        Email: r_5.Email,
        EmailAsbestConsulting: x_7,
        FirstName: r_5.FirstName,
        LastName: r_5.LastName,
        NationalInsuranceNumber: r_5.NationalInsuranceNumber,
        PhoneNumber: r_5.PhoneNumber,
    }), useFormValidator(nationalInsuranceNumber.Validator, (r_4, x_6) => ({
        Address: r_4.Address,
        Email: r_4.Email,
        FirstName: r_4.FirstName,
        LastName: r_4.LastName,
        NationalInsuranceNumber: x_6,
        PhoneNumber: r_4.PhoneNumber,
    }), useFormValidator(phoneNumber.Validator, (r_3, x_5) => ({
        Address: r_3.Address,
        Email: r_3.Email,
        FirstName: r_3.FirstName,
        LastName: r_3.LastName,
        PhoneNumber: x_5,
    }), useFormValidator(email.Validator, (r_2, x_4) => ({
        Address: r_2.Address,
        Email: x_4,
        FirstName: r_2.FirstName,
        LastName: r_2.LastName,
    }), useFormValidator(address.Validator, (r_1, x_3) => ({
        Address: x_3,
        FirstName: r_1.FirstName,
        LastName: r_1.LastName,
    }), useFormValidator(lastName.Validator, (r, x_2) => ({
        FirstName: r.FirstName,
        LastName: x_2,
    }), useFormValidator(firstName.Validator, (unitVar_1, x_1) => ({
        FirstName: x_1,
    }), useForm())))))))))))));
    const patternInput_1 = useFeliz_React__React_useState_Static_1505(false);
    const setDisable = patternInput_1[1];
    const disable = patternInput_1[0];
    return createElement(Col, {
        classes: singleton(Gap.M),
        children: toList(delay(() => append(singleton_1(TextField(lastName, "Naam", "", true)), delay(() => append(singleton_1(TextField(firstName, "Voornaam", "", true)), delay(() => append(singleton_1(TextField(email, "Emailadres", "", true)), delay(() => append(singleton_1(TextField(phoneNumber, "Telefoon", "", true)), delay(() => append(singleton_1(TextField(nationalInsuranceNumber, "Rijksregisternummer", "", true)), delay(() => append(singleton_1(TextField(personalIdOvam, "Persoons-id OVAM/VEKA (optioneel)", "", false)), delay(() => append(singleton_1(TextField(emailAsbestConsulting, "Email We Check", "", true)), delay(() => append(singleton_1(createElement("h2", {
            children: ["Rol"],
        })), delay(() => {
            let elements;
            return append(singleton_1(MuiHelpers_createElement(RadioGroup, [(elements = [OptionField(role, new AdiRole(0), AdiRoleModule_string(new AdiRole(0)), "", true), OptionField(role, new AdiRole(1), AdiRoleModule_string(new AdiRole(1)), "", true), OptionField(role, new AdiRole(2), AdiRoleModule_string(new AdiRole(2)), "", true), OptionField(role, new AdiRole(3), AdiRoleModule_string(new AdiRole(3)), "", true)], ["children", Interop_reactApi.Children.toArray(Array.from(elements))])])), delay(() => append(singleton_1(createElement(CreateAddressForm, {
                addressForm: address,
                heading: void 0,
                disabled: false,
            })), delay(() => append(singleton_1(createElement("h2", {
                children: ["Bedrijfsgegevens"],
            })), delay(() => {
                let elements_1;
                return append(singleton_1(MuiHelpers_createElement(RadioGroup, [["row", true], (elements_1 = [OptionField(companyType, new UiCompanyType(0), "Vennootschap", "", false), OptionField(companyType, new UiCompanyType(1), "Zelfstandige natuurlijk persoon", "", false)], ["children", Interop_reactApi.Children.toArray(Array.from(elements_1))])])), delay(() => append(singleton_1(TextField(vatNumber, "Ondernemingsnummer", "", true)), delay(() => append(singleton_1(TextField(bankAccount, "Zichtrekening", "", true)), delay(() => append(singleton_1(createElement("h2", {
                    children: ["Betalingstermijn"],
                })), delay(() => {
                    let elements_2;
                    return append(singleton_1(MuiHelpers_createElement(RadioGroup, [["row", false], (elements_2 = [OptionField(termOfPayment, new TermOfPayment(0), "7 dagen", "", false), OptionField(termOfPayment, new TermOfPayment(1), "14 dagen", "", false), OptionField(termOfPayment, new TermOfPayment(2), "30 dagen", "", false)], ["children", Interop_reactApi.Children.toArray(Array.from(elements_2))])])), delay(() => append(singleton_1(createElement("h2", {
                        children: ["Regio(s) waar de EPC-deskundige werkzaam is"],
                    })), delay(() => {
                        let elements_3;
                        return append(singleton_1(MuiHelpers_createElement(RadioGroup, [["row", false], (elements_3 = [createElement(RegionCheckbox, {
                            label: "West Flanders",
                            regionValue: new Region(0),
                            values: regionValues,
                            setRegions: setRegionValues,
                        }), createElement(RegionCheckbox, {
                            label: "East Flanders",
                            regionValue: new Region(1),
                            values: regionValues,
                            setRegions: setRegionValues,
                        }), createElement(RegionCheckbox, {
                            label: "Antwerp",
                            regionValue: new Region(2),
                            values: regionValues,
                            setRegions: setRegionValues,
                        }), createElement(RegionCheckbox, {
                            label: "Flemish Brabant",
                            regionValue: new Region(3),
                            values: regionValues,
                            setRegions: setRegionValues,
                        }), createElement(RegionCheckbox, {
                            label: "Limburg",
                            regionValue: new Region(4),
                            values: regionValues,
                            setRegions: setRegionValues,
                        })], ["children", Interop_reactApi.Children.toArray(Array.from(elements_3))])])), delay(() => append(singleton_1(createElement("h2", {
                            children: ["BTW-plichtig"],
                        })), delay(() => {
                            let elements_4;
                            return append(singleton_1(MuiHelpers_createElement(RadioGroup, [["row", false], (elements_4 = [OptionField(vatLiable, true, "ja", "", false), OptionField(vatLiable, false, "nee", "", false)], ["children", Interop_reactApi.Children.toArray(Array.from(elements_4))])])), delay(() => {
                                let matchValue_2;
                                return append((matchValue_2 = companyType.FieldValue, (matchValue_2 == null) ? singleton_1(null) : ((matchValue_2.tag === 1) ? singleton_1(null) : append(singleton_1(createElement("h2", {
                                    children: ["Gegevens vennootschap"],
                                })), delay(() => append(singleton_1(TextField(companyName, "Naam vennootschap", "", true)), delay(() => append(singleton_1(SelectOptionField(companyForm, "Vennootschapsvorm", "", true, TypeOfCorporation$reflection())), delay(() => append(singleton_1(TextField(telefoon, "Telefoon", "", true)), delay(() => singleton_1(TextField(emailadres, "Emailadres", "", true)))))))))))), delay(() => append(singleton_1(createElement(CreateAddressForm, {
                                    addressForm: addressCase,
                                    heading: "Adres zaak",
                                    disabled: false,
                                })), delay(() => singleton_1(createElement(Row, {
                                    classes: ofArray([Gap.M, MarginTop.L]),
                                    children: ofArray([MuiHelpers_createElement(Button, [["disabled", disable], ["color", "default"], ["variant", "contained"], ["onClick", (_arg_1) => {
                                        onCancel();
                                    }], ["children", Interop_reactApi.Children.toArray(["Annuleren"])]]), MuiHelpers_createElement(Button, [["disabled", disable], ["color", "primary"], ["variant", "contained"], ["onClick", (_arg) => {
                                        iterate((data) => {
                                            let matchValue, c;
                                            if (count(regionValues) === 0) {
                                                ProviderContext__enqueueSnackbar_Z1776A768(snackbar, "Minstens een regio moet geselecteerd zijn.", SnackbarProp_Variant_Z609E1E86("error"), new EnqueueSnackbarOption(1, false));
                                            }
                                            else {
                                                iterate((x_18) => {
                                                    let matchValue_1;
                                                    const company = new CompanyData(data.VatNumber, data.BankAccount, (matchValue_1 = data.TermOfPayment.Value, (matchValue_1.tag === 1) ? 14 : ((matchValue_1.tag === 2) ? 30 : 7)), data.VatLiable.Value, new Address(new NonEmptyString(addressCase.StreetField.FieldValue), new NonEmptyString(addressCase.NumberField.FieldValue), isNullOrEmpty(addressCase.BusField.FieldValue) ? (void 0) : (new NonEmptyString(addressCase.BusField.FieldValue)), new NonEmptyString(addressCase.PostalCodeField.FieldValue), new NonEmptyString(addressCase.City.FieldValue)), x_18.CompanyFormat);
                                                    const inspector = new AdiData(data.LastName, data.FirstName, data.Address, data.Email, data.PhoneNumber, data.NationalInsuranceNumber, isNullOrWhiteSpace(personalIdOvam.FieldValue) ? (void 0) : PersonIdOvam___UnsafeCreate_Z721C83C5(personalIdOvam.FieldValue), data.EmailAsbestConsulting, company, regionValues, data.Role.Value, new InspectorType(1));
                                                    setDisable(true);
                                                    onCreate(inspector)(() => {
                                                        setDisable(false);
                                                    });
                                                }, toArray((data.CompanyType.Value.tag === 1) ? {
                                                    CompanyFormat: new CompanyFormatData(0),
                                                } : ((matchValue = useFormValidator(emailadres.Validator, (r_14, x_17) => ({
                                                    CompanyName: r_14.CompanyName,
                                                    Emailadres: x_17,
                                                    Telefoon: r_14.Telefoon,
                                                    TypeOfCorp: r_14.TypeOfCorp,
                                                }), useFormValidator(telefoon.Validator, (r_13, x_16) => ({
                                                    CompanyName: r_13.CompanyName,
                                                    Telefoon: x_16,
                                                    TypeOfCorp: r_13.TypeOfCorp,
                                                }), useFormValidator(companyName.Validator, (r_12, x_15) => ({
                                                    CompanyName: x_15,
                                                    TypeOfCorp: r_12.TypeOfCorp,
                                                }), useFormValidator(companyForm.Validator, (unitVar_2, x_14) => ({
                                                    TypeOfCorp: x_14.Value,
                                                }), useForm())))).Validate(), (matchValue == null) ? (void 0) : ((c = matchValue, {
                                                    CompanyFormat: new CompanyFormatData(1, new CompanyInformationData(c.CompanyName, c.TypeOfCorp, c.Telefoon, c.Emailadres)),
                                                }))))));
                                            }
                                        }, toArray(form.Validate()));
                                    }], ["children", Interop_reactApi.Children.toArray(["Bewaren"])]])]),
                                }))))));
                            }));
                        }))));
                    }))));
                }))))))));
            }))))));
        })))))))))))))))))),
    });
}

export function EpcInspectorCreate(epcInspectorCreateInputProps) {
    const api = epcInspectorCreateInputProps.api;
    const currentPage = epcInspectorCreateInputProps.currentPage;
    const snackbar = useSnackbar();
    return createElement(Page, {
        currentPage: currentPage,
        title: "EPC-deskundige aanmaken",
        actions: [],
        children: [Card([createElement(CreateEpcInspectorForm, {
            onCreate: (data) => ((onCompleted) => {
                startImmediate(singleton_2.Delay(() => singleton_2.TryFinally(singleton_2.Delay(() => singleton_2.TryWith(singleton_2.Delay(() => singleton_2.Bind(api.CreateAdi(data), (_arg) => {
                    const result = _arg;
                    if (result.tag === 1) {
                        const err = result.fields[0];
                        console.error(err);
                        ProviderContext__enqueueSnackbar_Z1776A768(snackbar, err, SnackbarProp_Variant_Z609E1E86("error"), new EnqueueSnackbarOption(1, false));
                        return singleton_2.Zero();
                    }
                    else {
                        ProviderContext__enqueueSnackbar_Z1776A768(snackbar, "EPC-deskundige aangemaakt", SnackbarProp_Variant_Z609E1E86("success"), new EnqueueSnackbarOption(1, false));
                        RouterModule_nav(ofArray(Page$2__toUrl_2B594(epcInspectorDetail, result.fields[0].Value)), 1, 1);
                        return singleton_2.Zero();
                    }
                })), (_arg_1) => {
                    const e = _arg_1;
                    console.error(e);
                    ProviderContext__enqueueSnackbar_Z1776A768(snackbar, `Een onbekende fout is opgetreden. [${e.message}]`, SnackbarProp_Variant_Z609E1E86("error"), new EnqueueSnackbarOption(1, false));
                    return singleton_2.Zero();
                })), () => {
                    onCompleted();
                })));
            }),
            onCancel: () => {
                RouterModule_nav(ofArray(Page$2__toUrl_2B594(epcInspectors)), 1, 1);
            },
        })])],
    });
}

